module.exports = __webpack_public_path__ + "media/images/icon-stats-credits-a206e69f9ca2cdd8c8f93a92f578bbac.svg";